import {createSlice, PayloadAction} from "@reduxjs/toolkit"
import {limitOptionsSelect} from "../helps/optionsSelect"
import {asyncCreator} from "./sliceHelper"
import {WSSecurityLog} from "../types/WebSocketTypes"
import {securityLogApi, SecurityLogFilterQuery} from "../api/securityLogApi"
import {SecurityLogsResponse} from "../models/response"

export type SecurityLogFilter = {
    limit: number
    offset: number
}

type InitialStateType = {
    securityLogs: null | SecurityLogsResponse
    filter: SecurityLogFilter & SecurityLogFilterQuery
    ws: WSSecurityLog | null
}

const initialState: InitialStateType = {
    securityLogs: null,
    filter: {
        limit: limitOptionsSelect[0].value,
        offset: 0,
    },
    ws: null,
}

export const securityLogReducer = createSlice({
    name: 'securityLogReducer',
    initialState,
    reducers: {
        setSecurityLogs(state, {payload}) {
            state.securityLogs = payload
        },
        setSecurityLogFilter(state, {payload}) {
            state.filter = payload
        },
        setWSSecurityLog(state, {payload}: PayloadAction<WSSecurityLog | null>) {
            state.ws = payload
        },
    },
})

export const {setSecurityLogs, setSecurityLogFilter, setWSSecurityLog} = securityLogReducer.actions

export default securityLogReducer.reducer

export const getSecurityLogs = asyncCreator
('securityLogReducer/getSecurityLogs', securityLogApi.getSecurityLogs, setSecurityLogs)
